import type { FunctionComponent } from 'react';
import {
  Card,
  Text,
  paletteHelper,
  typographyHelper,
  spacingHelper,
  radiusHelper,
  mediaHelper,
  boxShadow,
} from '@property.com.au/ui-kit';
import styled from 'styled-components';

interface SchoolFactCardProps {
  title: string;
  subtitle: string;
}

const StyledCard = styled(Card)`
  ${boxShadow.defaultBoxShadow};
  background: ${paletteHelper('backgroundPrimaryHigh')};
  border-radius: ${radiusHelper('medium')};
  padding: calc(${spacingHelper('medium')} + ${spacingHelper('twoExtraSmall')});
  flex: calc((100% / 4) - 3 * ${spacingHelper('extraSmall')});

  ${mediaHelper('tabletMax')} {
    max-width: calc(100% / 2);
    flex: calc(100% / 2 - ${spacingHelper('extraSmall')});
  }
`;

const TitleText = styled(Text)`
  ${typographyHelper('overline')}
  text-align: center;
  margin-bottom: ${spacingHelper('twoExtraSmall')};
`;

const SubtitleText = styled(Text)`
  ${typographyHelper('title03')}
  text-align: center;
`;

export const SchoolFactCard: FunctionComponent<SchoolFactCardProps> = ({ title, subtitle }) => {
  return (
    <StyledCard>
      <TitleText>{title}</TitleText>
      <SubtitleText>{subtitle}</SubtitleText>
    </StyledCard>
  );
};
